import axiosInstance from "../../apiclient";
import { AxiosError } from 'axios';
import {
  getErrorMessage,
  createErrorTelemetryProperties,
  logError,
  logInformation,
  trackError
} from '../../utils/AppInsightUtils';
export const getReportData = async (endpoint: string, query: string, page: number) => {
  try {
    logInformation('Fetching report data', 'payLoadEstimatesAPI', 'getReportData');
    const response = await axiosInstance.get(`${endpoint}`);
    logInformation('Successfully fetched report data', 'payLoadEstimatesAPI', 'getReportData');
    return response.data;
  }
  catch (error) {
    trackError(error as Error);
    logError(
      getErrorMessage(new Error(`Failed to fetch Report data`)),
      'payLoadEstimatesAPI',
      'getReportData',
      createErrorTelemetryProperties(error as Error | AxiosError)

    );
    return null;
  }
}

